module.exports = __webpack_public_path__ + "images/category_lp/bike/banner_6b8fed92e488d43082eb8bb7b4167e29.png";